<div class="kt-portlet">

	<kt-portlet-header [title]="'Signal Strength'" [class]="'kt-portlet__head--lg'">

	</kt-portlet-header>

	<div class="kt-portlet__body">
		<mat-icon style="font-size: large;" matTooltip="Info about signal strength" style="cursor: pointer;" class="text-right ml-auto mr-5" (click)="open(content)">info</mat-icon>
		<div *ngIf="chartData" class="col-xl-8 col-md-12 col-sm-12 mx-auto">
			<div class="chart">
				<canvas  baseChart
				[datasets]="lineChartData"
				[labels]="lineChartLabels"
				[options]="lineChartOptions"
				[legend]="lineChartLegend"
				[chartType]="lineChartType"
				></canvas>
			</div>
		</div>
		<ng-template #content let-c="close" let-d="dismiss">
			<div class="modal-header">
			  <h4 class="modal-title">Signal Strength Ranges</h4>
			  <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
				<span aria-hidden="true">&times;</span>
			  </button>
			</div>
			<div class="modal-body">
				<table class="table">
					<thead>
					  <tr>
						<th>RSRP</th>
						<th>Signal Strength</th>
						<th>Description</th>
					  </tr>
					</thead>
					<tbody>
					  <tr style="color: rgb(51, 204, 51);">
						<td>>= -80 dBm</td>
						<td>Excellent</td>
						<td>Strong signal with maximum data speeds </td>
					  </tr>
					  <tr style="color: #dfb510;">
						<td>-80 dBm to -90 dBm</td>
						<td>Good</td>
						<td>Strong signal with good data speeds </td>
					  </tr>
					  <tr style="color: rgb(255, 102, 0);">
						<td>-90 dBm to -100 dBm </td>
						<td>Fair to poor</td>
						<td>Reliable data speeds may be attained, but marginal data with drop-outs is possible. When this value gets close to -100, performance will drop drastically </td>
					  </tr>
					  <tr style="color: rgb(204, 0, 0);">
						<td><= -100 dBm </td>
						<td>No signal</td>
						<td>Unreliable Connection  </td>
					  </tr>
					</tbody>
				  </table>
			</div>
			<div class="modal-footer">
			  <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
			</div>
		  </ng-template>
	</div>
</div>
